<i18n
  src="@/locales/views/open_queries/organization/basic_production/process/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}
    </h1>
  </div>

  <div class="bg-white shadow overflow-hidden sm:rounded-md">
    <ul role="list" class="divide-y divide-gray-200">
      <li
        v-for="harvest_process in harvest_processes"
        :key="harvest_process.id"
      >
        <div class="block hover:bg-gray-50">
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ harvest_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a
                  class="link"
                  @click.prevent="goToShowProcess(harvest_process.id)"
                >
                  <i class="fa-solid fa-eye"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.show_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="flex items-center text-sm text-gray-500">
                  <i
                    class="fa-solid fa-crate-apple flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{
                    numberWithPrecision(harvest_process.weights.total_weight)
                  }}
                  Kg
                </p>
                <p
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                >
                  <i
                    class="fa-solid fa-box-check flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ numberWithPrecision(harvest_process.weights.ok_weight) }}
                  Kg
                </p>
                <p
                  class="flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                >
                  <i class="fa-solid fa-ban flex-shrink-0" aria-hidden="true" />
                  <span class="space-icon"></span>
                  {{
                    numberWithPrecision(
                      harvest_process.weights.discarded_weight
                    )
                  }}
                  Kg
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Requester from "@/views/open_queries/requesters/organization/basic_production/process/list_processes.js";

export default {
  name: "OQOrgBasicProductionProcessListProcesses",
  props: {
    organization_id: {
      required: true
    }
  },
  data() {
    return {
      harvest_processes: []
    };
  },
  methods: {
    fetchHarvestProcesses: async function () {
      let response = await Requester.fetchHarvestProcesses(
        this.organization_id
      );
      this.harvest_processes = response.data;
    },
    goToShowProcess: function (harvest_process_id) {
      this.$router.push({
        name: "oq_organization_basic_production_process_show_production_path",
        params: {
          harvest_process_id: harvest_process_id,
          organization_id: this.organization_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.fetchHarvestProcesses())
    );
  }
};
</script>
